import { render } from "./Screens.vue?vue&type=template&id=78a5d194&scoped=true"
import script from "./Screens.vue?vue&type=script&lang=js"
export * from "./Screens.vue?vue&type=script&lang=js"

import "./Screens.vue?vue&type=style&index=0&id=78a5d194&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a5d194"]])

export default __exports__